function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  className: "st0",
  d: "M108.7,199.6H86.4v-8.4h22.3V199.6z M113.7,187H81.4v-8.4h32.3V187z M118.1,174.4H77.7v-4.2 c0-18.2-18.5-36-18.7-36.1l-0.1-0.1c-9.7-9.9-15.3-23.7-15.3-37.7c0-14.2,5.4-27.6,15.3-37.7c9.9-10.1,23.1-15.6,37.1-15.6 c14,0,27.2,5.5,37.1,15.6c9.9,10,15.3,23.4,15.3,37.6c0,14.2-5.6,28-15.3,37.9c-0.1,0.1-14.9,15.6-14.9,36.2V174.4z M85.8,166 h24.1c1.7-21.9,16.4-37.2,17.1-37.9c8.2-8.4,12.9-20,12.9-32c0-12-4.6-23.2-12.9-31.7c-8.3-8.4-19.3-13.1-31.1-13.1 c-11.7,0-22.8,4.7-31.1,13.1c-8.3,8.5-12.9,19.8-12.9,31.8c0,11.9,4.7,23.5,12.9,31.8C66.1,129.4,83.5,146.4,85.8,166z M95.9,109 L81.7,94.5l-11.3,11.5l-6-5.9l17.2-17.5L95.9,97l14.3-14.5l17.2,17.5l-6,5.9l-11.3-11.5L95.9,109z M191.3,101.7h-29.2v-8.4h29.2 V101.7z M29.2,101.2H0v-8.4h29.2V101.2z M155.4,67.3l-4.2-7.2l25.3-14.9l4.2,7.2L155.4,67.3z M36.1,66.9L10.8,52l4.2-7.2 l25.3,14.9L36.1,66.9z M132.7,41l-7.3-4.1l14.6-25.7l7.3,4.1L132.7,41z M59,40.7L44.4,15l7.3-4.1l14.6,25.7L59,40.7z M100.1,29.7 h-8.4V0h8.4V29.7z"
})));

var SvgLightBulbOn = function SvgLightBulbOn(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 191.3 199.6",
    style: {
      enableBackground: "new 0 0 191.3 199.6"
    },
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/light-bulb-on.c15b2802.svg";
export { SvgLightBulbOn as ReactComponent };